import { API_endpoints } from "../config";

export const getKidContact = async (KidID:number): Promise<any> => {
    try {
        
        const response = await fetch(API_endpoints.getKidContact, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({'kid_id':KidID}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von kids contact Daten.");
        }
        const data = await response.json();
        return data;

        
    } catch (error) {
        console.error("Fehler beim Laden von contact Daten:", error);
    }
};
